"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreDivider = _interopRequireDefault(require("@vfuk/core-divider"));

var _coreImage = _interopRequireDefault(require("@vfuk/core-image"));

var _coreMatchMedia = require("@vfuk/core-match-media");

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/PartnerLinks.style"));

var _hooks = require("../../hooks");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PartnerLinks = function PartnerLinks(_ref) {
  var partnerLinks = _ref.partnerLinks,
      onInteractionClick = _ref.onInteractionClick,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      footerTheme = _ref.footerTheme,
      dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      sm = _useBreakpoints.sm;

  var getLinksRowLength = function getLinksRowLength() {
    if (sm) return 2;
    return 4;
  };

  var linksList = (0, _hooks.useLinksList)(partnerLinks, getLinksRowLength());
  var _footerTheme$appearan = footerTheme.appearance[appearance],
      dividerAppearance = _footerTheme$appearan.dividerAppearance,
      inverseDivider = _footerTheme$appearan.inverseDivider;
  return /*#__PURE__*/_react["default"].createElement(Styled.PartnerLinks, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, linksList.map(function (row, rowIndex) {
    return /*#__PURE__*/_react["default"].createElement(Styled.LinksRow, {
      key: "footer-partner-links-list-".concat(rowIndex),
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "row-".concat(rowIndex))
    }, /*#__PURE__*/_react["default"].createElement(Styled.RowListGroup, null, row === null || row === void 0 ? void 0 : row.map(function (link, linkIndex) {
      return /*#__PURE__*/_react["default"].createElement(Styled.ListItemWrapper, {
        key: link.id
      }, /*#__PURE__*/_react["default"].createElement(Styled.InteractionWrapper, {
        href: link.href,
        customRouterProps: link.customRouterProps,
        onClick: onInteractionClick,
        dataAttributes: link.dataAttributes,
        footerTheme: footerTheme,
        appearance: appearance
      }, link.image && /*#__PURE__*/_react["default"].createElement(_coreImage["default"], {
        sm: {
          src: link.image
        },
        alt: link.srText || link.text,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "link-".concat(linkIndex, "-image"))
      }), link.text), linkIndex !== row.length - 1 && /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
        appearance: dividerAppearance,
        orientation: "vertical",
        inverse: inverseDivider
      }));
    })));
  }));
};

PartnerLinks.displayName = "PartnerLinks";
var _default = PartnerLinks;
exports["default"] = _default;
//# sourceMappingURL=PartnerLinks.js.map